import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


// Model
import { ResponseBase } from '../models/response-base';
import { ProdutoElegibilidade } from '../models/produto-elegibilidade';


@Injectable({
  providedIn: 'root'
})
export class ProdutoElegivelService {
  API: string = environment.API + 'Portal/produtoselegibilidades';

  constructor(private http: HttpClient) { }

  getProdutosElegivel(cedenteGuid: string, gestorGuid: string, categoria: number = 0): Observable<ResponseBase<ProdutoElegibilidade[]>> {
    let params = new HttpParams();
    params = params.append('categoria', categoria.toString());
    return this.http.get<ResponseBase<ProdutoElegibilidade[]>>(`${this.API}/cedentes/${cedenteGuid}`, {params});
  }



}
